import {Injectable} from "@angular/core";
import {ProductCollectionsEnum} from "../../../shared/enums/product-collections.enum";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {QueryStringSerializationService} from "../../../shared/services/query-string-serialization.service";
import {CollectionSearchParamsModel} from "../../models/collection-search-params.model";
import {CaCollectionParamsFilterModel} from "../../models/search-params/filters/ca-collection-params-filter.model";
import {HlaCollectionParamsFilterModel} from "../../models/search-params/filters/hla-collection-params-filter.model";
import {CollectionSearchConfigService} from "../collection-search-config.service";

@Injectable({
    providedIn: "root"
})
export class CollectionSearchParamsFactoryService {
    public constructor(
        private configService: CollectionSearchConfigService,
        private queryStringSerializationService: QueryStringSerializationService
    ) {
    }

    public createParamsByQueryString(queryString: string): CollectionSearchParamsModel {
        queryString = queryString || "";

        const searchParamsData = this.queryStringSerializationService.deserialize<CollectionSearchParamsModel>(queryString);

        const collection = Object.keys(ProductCollectionsEnum).map(x => ProductCollectionsEnum[x]).indexOf(searchParamsData.collection) > -1 // be safe
                ? searchParamsData.collection
                : this.configService.getDefaultCollectionValue();
        const pageNumber = searchParamsData.pageNumber > 0 ? +searchParamsData.pageNumber : 1;
        const filter = this.createFilter(collection, searchParamsData.filter);
        const sorting = searchParamsData.sorting || this.configService.getDefaultSortingOptionValue();

        const searchParams = new CollectionSearchParamsModel(collection, sorting, pageNumber, filter);

        return searchParams;
    }

    public createFilter(collection: ProductCollectionsEnum, initialState: EmptySearchParamsFilterModel = null): EmptySearchParamsFilterModel {
        initialState = initialState || {} as EmptySearchParamsFilterModel;

        let filter: EmptySearchParamsFilterModel;

        switch (collection) {
            case ProductCollectionsEnum.CA: {
                const sourceParams = initialState as CaCollectionParamsFilterModel;
                filter = new CaCollectionParamsFilterModel(
                    sourceParams.karyotype || "",
                    sourceParams.chromosomeAffectedA || "",
                    sourceParams.chromosomeAffectedB || "",
                    sourceParams.chromosomeAffectedC || "",
                    sourceParams.ageMin || "",
                    sourceParams.ageMax || ""
                );
                break;
            }
            case ProductCollectionsEnum.ECACCHLA: {
                const sourceParams = initialState as HlaCollectionParamsFilterModel;
                filter = new HlaCollectionParamsFilterModel(
                    sourceParams.iHWNumber || "",
                    sourceParams.serologicalFields || {},
                    sourceParams.dnaProbeFields || {},
                    sourceParams.nonHlaGenesFields || {}
                );
                break;
            }
            default:
                throw new Error("Not supported collection");
        }

        return filter;
    }

    public serialiseToQueryString(searchParams: CollectionSearchParamsModel): string {
        return this.queryStringSerializationService.serialize(searchParams);
    }

}
